import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import _ from "lodash";
import { AdminDataState } from "types/general";

const initialState: AdminDataState = {
  email: "",
  username: "",
  firstName: "",
  lastName: "",
  roles: [],
};

export const adminDataSlice = createSlice({
  name: "adminData",
  initialState,
  reducers: {
    setAdminData: (state, action: PayloadAction<AdminDataState>) => {
      state.email = action.payload.email;
      state.username = action.payload.username;
      state.firstName = action.payload.firstName;
      state.lastName = action.payload.lastName;
      state.roles = _.cloneDeep(action.payload.roles);
    },
  },
});

export const { setAdminData } = adminDataSlice.actions;

export const selectEmail = (state: RootState) => state.adminData.email;
export const selectUsername = (state: RootState) => state.adminData.username;
export const selectFirstName = (state: RootState) => state.adminData.firstName;
export const selectLastName = (state: RootState) => state.adminData.lastName;
export const selectRole = (state: RootState) => state.adminData.roles?.[0];

export default adminDataSlice.reducer;
